export default __webpack_public_path__ + "static/media/293.e5e41adb.jpg";